import 'bootstrap';
import slick from 'slick-slider';
import magnificPopup from 'magnific-popup';


import { library, dom } from "../../node_modules/@fortawesome/fontawesome-svg-core";
import { faMagnifyingGlass, faXmarkCircle } from '../../node_modules/@fortawesome/pro-solid-svg-icons';
import { faFacebook, faTwitter, faInstagram } from '../../node_modules/@fortawesome/free-brands-svg-icons';
import { faPlus } from '../../node_modules/@fortawesome/pro-regular-svg-icons'
import { faTimes } from '../../node_modules/@fortawesome/pro-regular-svg-icons'
import { faChevronRight } from '../../node_modules/@fortawesome/pro-regular-svg-icons'
import { faChevronLeft } from '../../node_modules/@fortawesome/pro-regular-svg-icons'
import { faExclamation, faCirclePhone, faCircleEnvelope, faCircleLocationArrow } from '../../node_modules/@fortawesome/pro-solid-svg-icons'
import { faDownload, faCircleLeft, faUser, faCircleRight, faArrowRightToBracket, faArrowRightFromBracket } from '../../node_modules/@fortawesome/pro-solid-svg-icons'


library.add(
  faMagnifyingGlass,
  faXmarkCircle,
  faTwitter,
  faFacebook,
  faInstagram,
  faPlus,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faExclamation,
  faDownload,
  faCircleLeft,
  faCircleRight,
  faCirclePhone, faCircleEnvelope, faCircleLocationArrow, faUser, faArrowRightToBracket, faArrowRightFromBracket
)
dom.watch();

